export default __webpack_public_path__ + "static/media/inventory-filters-icon.053f9c7b.svg";